import React, { useState, useEffect } from 'react'
import CreateTemplate from '../../components/Templates/CreateTemplate'
import TemplatesList from '../../components/Templates/TemplatesList'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { getTemplates, getCategories } from '../../utils/templatesApi'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'

const Templates = ({
  items,
  onSelect,
  onDelete,
  reloadTrigger,
  role,
  setHeading,
  userId
}) => {
  const [refresh, setRefresh] = React.useState(false)
  const [list, setList] = useState([])
  const [Options, setOptions] = useState([])
  const [search, setSearch] = useState('')
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = React.useState(0)
  const [loading, setLoading] = useState(false)

  const handleChangePage = (event, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0) // reset to first page on rows change
  }

  const templatesList = async () => {
    try {
      setLoading(true)
      const response = await getTemplates(page, rowsPerPage, search)
      setTotalCount(response?.meta?.totalItems || 0)
      setOptions(response?.data)
      setLoading(false)

    } catch (error) {
      console.error('Error fetching templates:', error)
      toast.error('Failed to load templates')
      setLoading(false)

    }

  }

  const getList = async () => {
    try {
      const response = await getCategories()
      setList(response.data)
    } catch (error) {
      toast.error('failed to load categories')
    }
  }
  useEffect(() => {
    getList()
    if (typeof setHeading === 'function') {
      setHeading('Templates')
    }
  }, [])

  useEffect(() => {
    templatesList()
  }, [reloadTrigger, page, rowsPerPage, search])

  return (
    <div>

      {role === 'admin' || role === 'super-admin' && (
        <>
          <CreateTemplate
            items={items}
            onSelect={onSelect}
            setRefresh={setRefresh}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '20px',
              marginBottom: '20px',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Autocomplete
              disablePortal
              options={Object.keys(list).map((key, index) => ({
                id: list[key].id,
                category_name: list[key].category_name,
              }))}
              value={
                list
                  .map(opt => ({
                    id: opt.id,
                    category_name: opt?.category_name || '',
                  }))
                  .find(option => option.category_name === search) || null
              }
              onChange={(event, newValue) => {
                setSearch(newValue?.category_name || '')
              }}
              getOptionLabel={option => option.category_name || ''}
              // getOptionSelected={(option, value) => option.id === value.id}
              sx={{ width: 300 }}
              renderInput={params => (
                <TextField {...params} label='Categories' />
              )}
            />
            <Button
              type='submit'
              variant='contained'
              sx={{
                textTransform: 'capitalize',
                height: '50px',
                width: '120px',
                fontSize: '16px',
                display: 'flex',
                justifySelf: 'end',
                backgroundColor: '#111827',
                // mt: 4,
              }}
              onClick={onSelect}
            >
              Create
            </Button>
          </div>
        </>
      )}

      <TemplatesList
        onDelete={onDelete}
        reloadTrigger={reloadTrigger}
        role={role}
        onSelect={onSelect}
        refresh={refresh}
        setRefresh={setRefresh}
        Options={Options}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleChangePage={handleChangePage}
        rowsPerPage={rowsPerPage}
        totalCount={totalCount}
        page={page}
        setTotalCount={setTotalCount}
        search={search}
        setSearch={setSearch}
        items={items}
        setOptions={setOptions}
        setPage={setPage}
        loading={loading}
        setLoading={setLoading}
        userId={userId}
      />
    </div>
  )
}

export default Templates
